/* eslint-disable @next/next/no-img-element */
import BoostJackpotPopup from 'components/enter/BoostJackpotPopup';
import MenuSection from 'components/layout/header/MenuSection';
import React, { useState } from 'react';
import { extendClassName } from 'utils/common';
import { colors } from 'utils/constants';
import { EntryMethod } from '../EntryMethod';
import { BoostIcon } from './BoostIcon';
import { BoostSectionHeadingV2 } from './BoostSectionHeadingV2';
import { BoostSwitch } from './BoostSwitch';
import { Description } from './Description';

interface IBoostJackpotSectionV2 {
  additionalClassName?: string;
  noIcon?: boolean;
  moneySavingTip?: boolean;
  disabled?: boolean;
  replaceSwitchWithLoadingSpinner?: boolean;
  entryMethod: EntryMethod;
  boostCostPerEntry: number;
  boostJackpot: boolean;
  setBoostJackpot: (boost: boolean) => void;
  onAnyUserAction: () => void;
  collapsible?: boolean;
  glowColor?: string;
  style?: React.CSSProperties;
}
const BoostJackpotSectionV2 = ({
  noIcon,
  moneySavingTip,
  disabled,
  replaceSwitchWithLoadingSpinner,
  entryMethod,
  boostCostPerEntry,
  boostJackpot,
  setBoostJackpot,
  onAnyUserAction = () => {},
  collapsible,
  glowColor,
  additionalClassName,
  style,
}: IBoostJackpotSectionV2) => {
  const [showBoostJackpotPopup, setShowBoostJackpotPopup] = useState(false);
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className={extendClassName('boostJackpotSection flexCentered', [
        collapsible ? 'collapsible' : '',
        additionalClassName || '',
      ])}
      style={style}
    >
      {showBoostJackpotPopup && (
        <BoostJackpotPopup
          entryMethod={entryMethod}
          boostCostPerEntry={boostCostPerEntry}
          onClose={() => setShowBoostJackpotPopup(false)}
          ctaText={undefined}
          ctaOnClick={undefined}
        />
      )}

      {collapsible ? (
        <MenuSection
          expanded={expanded}
          setExpanded={setExpanded}
          titleComponent={
            <>
              <BoostSectionHeadingV2
                setShowBoostJackpotPopup={setShowBoostJackpotPopup}
              />
            </>
          }
        >
          <div className="flexRow flexSpaceBetween">
            <Description
              entryMethod={entryMethod}
              boostCostPerEntry={boostCostPerEntry}
            />
            <BoostSwitch
              replaceSwitchWithLoadingSpinner={replaceSwitchWithLoadingSpinner}
              boostJackpot={boostJackpot}
              setBoostJackpot={setBoostJackpot}
              onAnyUserAction={onAnyUserAction}
              glowColor={glowColor}
              disabled={disabled}
              onClickWhileDisabled={() => setShowBoostJackpotPopup(true)}
            />
          </div>
        </MenuSection>
      ) : (
        <>
          <div className="flex" style={{ marginBottom: '0.5em' }}>
            {noIcon && (
              <div className=" flex items-center">
                <BoostIcon />
              </div>
            )}
            <div className="px-2">
              <BoostSectionHeadingV2
                setShowBoostJackpotPopup={() => setShowBoostJackpotPopup(true)}
              />
              <Description
                entryMethod={entryMethod}
                boostCostPerEntry={boostCostPerEntry}
                style={{ marginTop: '0.25em', marginLeft: '0.5em' }}
              />
            </div>
            <BoostSwitch
              replaceSwitchWithLoadingSpinner={replaceSwitchWithLoadingSpinner}
              boostJackpot={boostJackpot}
              setBoostJackpot={setBoostJackpot}
              onAnyUserAction={onAnyUserAction}
              glowColor={glowColor}
              disabled={disabled}
              onClickWhileDisabled={() => setShowBoostJackpotPopup(true)}
            />
          </div>
        </>
      )}

      {!expanded && moneySavingTip}

      <style jsx>
        {`
          .boostJackpotSection {
            border: 3px solid ${colors.primaryBrandGray}25;
            border-radius: 10px;
            width: 100%;
            align-items: flex-start;
          }

          .boostJackpotSection.collapsible {
            border: none;
            padding: 0;
          }

          :global(
              .boostJackpotSection.collapsible .menuSection .childrenSection
            ) {
            align-items: center;
          }

          :global(.boostJackpotSection.collapsible .menuSection .boostSwitch) {
            max-width: 450px;
            font-weight: 700;
            margin-top: 1em;
          }

          :global(.boostJackpotSection.collapsible .menuSection .sectionTitle),
          :global(
              .boostJackpotSection.collapsible
                .menuSection
                .sectionTitle.noSelect
            ) {
            padding: 0;
          }

          :global(
              .boostJackpotSection.collapsible .menuSection .titleContainer
            ) {
            display: flex;
            text-transform: none;
          }

          :global(.boostJackpotSection.collapsible .menuSection p.heading) {
            margin: 0;
            font-size: 1em;
          }
        `}
      </style>
    </div>
  );
};

export default BoostJackpotSectionV2;
